import React from 'react';
import styled from 'styled-components';
import {mmWave as mmWv} from '../map/index'

const MapContainer = styled.div`
  border: 0.0625rem solid #959595;
  position: relative;
  min-height: 320px;
  overflow: hidden;
  width:100%;
  min-width:300px;
  @media (max-width: 768px) {
    min-height: 350px;
}
.mapboxgl-popup-close-button,.mapboxgl-popup-close-button:hover{
  color:black;
  padding:1px 6px;
}
.mapboxgl-ctrl-traffic{
  display:none;
}
`;

const RefreshDiv = styled.div`
position: absolute;
top: 40%;
right: 0;
display:inline-block;
z-index: 100;  
cursor:pointer;
margin:10px;
`;
const RefreshIcon = styled.div`
height:35px;
width:35px;
background-image: url(//www.verizonwireless.com/content/dam/vzwcom/5g/images/refreshbk.png);
margin:auto !important;;
`;
const RefreshText = styled.div`
  color:rgb(0,0,0);
  background-color:blue:
  font-size:12px  
.`;
const MapView = styled.div`
  height: 350px;
`;

class LqwVltMap extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      latestUserPlace: {},
      mapDl: null,
    };

    this.showLoader;
    this.hideLoader;

    // for debugging
    this.enableConsoleLog = true;

    this.testSvg = '<svg  width="72" height="24" xmlns="http://www.w3.org/2000/svg">' +
      '<rect stroke="black" fill="blue" x="1" y="1" width="70" height="22" />' +
      '<text x="36" y="18" font-size="12pt" font-family="Arial" font-weight="bold" ' +
      'text-anchor="middle" fill="white" >SVG img</text></svg>';

    this.defMarkerIcon = `<svg width="35px" height="46px" viewBox="0 0 35 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M17.5,0.503199174 C8.25,0.503199174 0.75,8.05118679 0.75,17.3603715 C0.75,19.6247678 1.25,21.8891641 2,24.1535604 C4.5,29.6887513 17.5,45.7911249 17.5,45.7911249 C17.5,45.7911249 29.25,31.1983488 32.5,24.40516 C33.5,22.1407637 34.25,18.869969 34.25,17.3603715 C34.25,8.05118679 26.75,0.503199174 17.5,0.503199174 Z" id="Path" fill="#ffa500"></path>
        <g id="Group" transform="translate(6.500000, 6.000000)">
            <path d="M11,0 C4.85294118,0 0,4.85294118 0,11 C0,17.1470588 4.85294118,22 11,22 C17.1470588,22 22,17.1470588 22,11 C22,4.85294118 16.8235294,0 11,0 Z" id="Path" fill="#FFFFFF"></path>
            <g id="24" transform="translate(3.000000, 3.000000)" fill="#000000" font-family="VerizonNHGeDS-Bold, Verizon NHG eDS" font-size="12" font-weight="bold">
              <text text-anchor="middle"><tspan x="8" y="12">VZ</tspan></text>
            </g>
        </g>
      </svg>`;


  }

  initVltMap = async () => {
    this.consoleLog('Begin initialization');
    this.showLoader();
   
    let { center } = this.props;
    if (!center || !center.lat || !center.lng) {
      //use default if center not provided
      center = { lat: 39.7392, lng: -104.9903 };
    }
    this.setState({ latestUserPlace: center});

    let mapElem = document.getElementById(this.props.id);
    if (mapElem) {
      const { VLTMap } = window;
      const VLT = VLTMap({ key: 'eYXrFFix3mAi6g6xiI1ihzT5rqYPpHMi' });
      const { zoomIndex } = this.props;
      const map = await VLT.Map(mapElem, { zoom: zoomIndex, zoomButtons: true, vzLogoPosition: 'bottom-left', layerSwitcherPosition: 'bottom-left', vzLogoSize: 'small', center: center })
      //window.map = map      
      this.setState({ mapDl: map });
      // map.setCenter({ lat: latitude, lng: longitude })
      // map.setZoom(17)
      map.on('load', () => {mmWv(map)})
      let shapeOverlays = [];
      
      const { markers, polygons } = this.props;
      if (Array.isArray(markers) && markers.length > 0) {
        const markerLayerList = this.addMarkers(markers);
        markerLayerList.forEach(markerLayer => shapeOverlays.push(markerLayer));
      }

      if (Array.isArray(polygons) && polygons.length > 0) {
        const polygonLayerList = this.getPolygonLayer(polygons);
        polygonLayerList.forEach(polygonLayer => shapeOverlays.push(polygonLayer));
      }
      
      map.setLayers(shapeOverlays);
    }

    this.hideLoader();
    this.consoleLog('End initialization');
  }

  getPolygonLayer = (polygonList) => {
    let polygonLayerList = [];
    const map = this.state.mapDl;
    if (map && Array.isArray(polygonList)) {
      this.setState({ buildingId: polygonList[0].properties.buildingId});

      polygonList.forEach(polygonDetails => {
        const polygonFeats = {
          "type": "FeatureCollection",
          features: [
            {
              "type": "Feature",
              "geometry": {
                "type": "Polygon",
                "coordinates": polygonDetails.coordinates
              },
              "properties": polygonDetails.properties          
            }
          ]
        };

        const polygonOpts = {
          getStyle: polygonDetails.style
        };

        const { layerTypes } = map;
        const polygonLayer = map.createLayer(polygonFeats, layerTypes.polygon, polygonOpts);

        polygonLayerList.push(polygonLayer);
      });
    }

    return polygonLayerList;
  };

  centerMap = () => {
    // const map = this.state.mapDl;
    // map.setZoom(17);
    // map.setCenter(this.state.latestUserPlace);
    this.initVltMap();
  };

  getMarkerFeature = (markerDetails) => {
    const { coordinates, properties } = markerDetails;
    const markersFeats = {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [
              coordinates.lng,
              coordinates.lat
            ]
          },
          "properties": properties
        }

      ]
    };

    return markersFeats;
  };

  addMarkers = (markerList) => {
    let markerLayerList = [];    
    const map = this.state.mapDl;
    if (map && markerList.length > 0) {
      markerList.forEach(markerDetails => {
        const { icon, draggable, onMarkerDrag, onFeatureLeaveMsg } = markerDetails;
        let markerOptions = {};

        if (icon) {
          markerOptions.getIcon = (feat) => icon;
        }
         
        if (draggable) {
          markerOptions.onDragEnd = (feature, xy) => {
            const featureIntersect = map.getFeaturesAtPoint(xy);
            onMarkerDrag(xy.lat,xy.lng,featureIntersect);
            console.log('feature drag', feature, featureIntersect);
            const infoBubblePosition = [xy.lng, xy.lat];
            const infoBubbleContent = onFeatureLeaveMsg || 'Marker outside of feature.';
            if (featureIntersect.length == 0) {
              this.showInfoBubble(infoBubblePosition, infoBubbleContent);
            }
          };

          if (!icon) {
            markerOptions.getIcon = (feat) => this.defMarkerIcon;
          }
        }        

        const { layerTypes } = map;
        const markersFeats = this.getMarkerFeature(markerDetails);
        const markerLayer = map.createLayer(markersFeats, layerTypes.marker, markerOptions);

        markerLayerList.push(markerLayer);
      });
      
    }

    return markerLayerList;
  };

  showInfoBubble = (position, infoBubbleContent) => {
    const map = this.state.mapDl;
    map && map.openInfoBubble({
      position: position,
      content: infoBubbleContent,
    })
  };

  setUpLoader = () => {
    const { loader } = this.props;
    if (loader && typeof loader.show === 'function' && (typeof loader.hide === 'function')) {
      this.showLoader = loader.show;
      this.hideLoader = loader.hide;
    } else {
      this.showLoader = () => {};
      this.hideLoader = () => {};
    }
  };

  consoleLog = (message) => {
    this.enableConsoleLog && console.log('%c[VLT Map] ' + message, 'background-color: tomato; color: black; padding: 1px 6px 1px 0;');
  };

  componentDidMount() {
    // set up loader
    this.setUpLoader();

    // initialize map
    if (!window.VLTMap) {
      this.showLoader();

      let scriptEl1 = document.createElement('script');
      let scriptEl2 = document.createElement('script');
      let linkEl = document.createElement('link');
      let headEl = document.getElementsByTagName('head')[0];

      linkEl.href = 'https://api.mapbox.com/mapbox-gl-js/v2.5.1/mapbox-gl.css';
      linkEl.rel = 'stylesheet';
      scriptEl1.src = 'https://api.mapbox.com/mapbox-gl-js/v2.5.1/mapbox-gl.js';
      scriptEl2.src = 'https://vltcdn-public.s3.amazonaws.com/mapping/production/v2.0.0/index.js';

      linkEl.onload = () => {
        scriptEl1.onload = () => {
          scriptEl2.onload = this.initVltMap;
          headEl.appendChild(scriptEl2);
          this.hideLoader();
        }
        headEl.appendChild(scriptEl1);
      };
      headEl.appendChild(linkEl);
    }
    else {
      this.initVltMap();
    }
  }

  render() {
    return (
      <React.Fragment>
        <MapContainer>
          <RefreshDiv id="refreshId" onClick={() => this.centerMap()}>
            <RefreshIcon className="mapRefreshIcon" title="Click to recenter the map"></RefreshIcon>
            <RefreshText className="mapRefreshText">Refresh</RefreshText>
          </RefreshDiv>
          <MapView id={this.props.id} />
        </MapContainer>
      </React.Fragment>

    );
  }
}

export default LqwVltMap;